import { Skeleton } from '@/components/ui/skeleton';
import { TableBody, TableCell, TableRow } from '@/components/ui/table';

export interface DataTableSkeletonProps {
  rows: number;
  columns: number;
  rowHeight: number;
  selectable: boolean;
}

/** Widths that repeat without looking generated. */
const WIDTHS = ['w-32', 'w-20', 'w-40', 'w-24', 'w-16', 'w-28'] as const;

/** Loading state with the shape of the real table, not a spinner (ARCHITECTURE §3.6). */
export function DataTableSkeleton({
  rows,
  columns,
  rowHeight,
  selectable,
}: DataTableSkeletonProps) {
  return (
    <TableBody aria-busy>
      {Array.from({ length: rows }, (_, rowIndex) => (
        <TableRow key={rowIndex} style={{ height: rowHeight }}>
          {selectable && (
            <TableCell className="w-10 px-0 text-center">
              <Skeleton className="mx-auto size-4 rounded-sm" />
            </TableCell>
          )}
          {Array.from({ length: columns }, (_, columnIndex) => (
            <TableCell key={columnIndex} className="px-4">
              <Skeleton
                className={`h-3.5 ${WIDTHS[(rowIndex + columnIndex) % WIDTHS.length] ?? 'w-24'}`}
              />
            </TableCell>
          ))}
        </TableRow>
      ))}
    </TableBody>
  );
}
